<template>
  <b-modal ref="modal"
           title-tag="div"
           :cancel-variant="data.cancelVariant || undefined"
           :header-bg-variant="data.headerBgVariant || undefined"
           :footer-bg-variant="data.footerBgVariant || undefined"
           :header-text-variant="data.headerTextVariant || undefined"
           footer-class="d-none"
           :dialog-class="data.dialogClass"
           :content-class="data.contentClass"
           :body-class="data.bodyClass || 'p-0'" :size="data.size || 'md'"
           :title="titleModal || data.title"
           :centered="data.centered || false"
           :scrollable="false"
           :no-close-on-backdrop="data.noCloseOnBackdrop || false"
           :no-close-on-esc="data.noCloseOnEsc || false"
           :hide-header-close="data.hideHeaderClose || false"
           @hide="hide" @hidden="onClose" @shown="onShow"
  >
    <template slot="modal-header-close">
      <b-button size="sm" variant="primary" class="ni ni-close" @click="close()"></b-button>
    </template>
    <component
      :is="data.dclass"
      v-if="opened"
      :variant="data.variant"
      :catalog="data.catalog"
      :model="data.model"
      :extra="data.extra"
      @update="selectValue"
      @cancel="closeModal"
      @changetitle="setTitle"
    >
    </component>
  </b-modal>
</template>
<script>
    import modal from "@dialogs/modal.vue";

    export default {
        mixins: [modal],
        data() {
            return {
                response: {type: Object},
                data: {type: Object, default: {}},
                opened: {type: Boolean, default: false},
                titleModal: null
            };
        },
        methods: {
            onShow() {
                this.opened = true;
            },
            onClose() {
                this.opened = false;
                this.response = {};
            },
            /** Overwrite method
             * @param variant
             */
            selectValue(variant, extraData) {
                // this.response = variant;
                this.response = {
                    cod: this.data.variant.cod,
                    value: variant,
                    img: extraData ? extraData.img : null,
                    imgColor: extraData ? extraData.imgColor : null,
                    option: extraData ? extraData.option : null
                };
                this.close(1);
            },
            closeModal() {
                this.close(0);
            },
            setTitle(title) {
                this.titleModal = title;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/dialogs/modalDClass.vue